import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BankingArchive from "../../../Components/Archive/Banking/BankingArchive";
import styles from "./Page_Archive.module.css";
import ArchiveHeader from "./ArchiveHeader";
import BuySellArchive from "../../../Components/Archive/BuySell/BuySellArchive";
import RAArchive from "../../../Components/Archive/RA/RAArchive";
import RFQArchive from "../../../Components/Archive/RFQ/RFQ";
import TradeConnectInitiateArchive from "../../../Components/Archive/TradeConnect/TradeConnectInitiateArchive";

const Page_Archive = () => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  );
  const mapingData = useSelector((s) => s?.platformSlice?.userPaymentConfigs);
  const state = useSelector(
    (store) => store?.persistedReducer?.company?.stateLabel,
  );

  const isBanking = role === "BANKING";
  const [type, setType] = useState(isBanking ? "Banking" : "Bilateral");
  const [status, setStatus] = useState("Closed");
  const [raSubType, setRaSubType] = useState("Open");
  const [rfpSubType, setRfpSubType] = useState(
    state === "OD" ? "Interstate" : "Intrastate",
  );
  const [tcSubType, setTcSubType] = useState("Place Bid");

  function onBack() {
    window.history.back();
  }

  return (
    <div className={styles.archiveWrapper}>
      <ArchiveHeader
        onBack={onBack}
        initialType={type}
        initialStatus={status}
        onTypeChange={setType}
        onStatusChange={setStatus}
        onRaSubTypeChange={setRaSubType}
        onRfpSubTypeChange={setRfpSubType}
        onTcSubTypeChange={setTcSubType}
        types={
          isBanking
            ? ["Banking"]
            : [
                "Bilateral",
                ...(mapingData?.some((e) => e?.productName === "TRADE_CONNECT")
                  ? ["TradeConnect"]
                  : []),
                ...(mapingData?.some((e) => e?.productName === "RFP_RFQ")
                  ? ["RFP"]
                  : []),
                ...(mapingData?.some((e) => e?.productName === "RA")
                  ? ["RA"]
                  : []),
              ]
        }
      />
      <div
        style={{
          padding: "15px",
        }}
      >
        {role === "BANKING" ? (
          <BankingArchive type={type} status={status} />
        ) : type === "Bilateral" ? (
          <BuySellArchive type={type} status={status} />
        ) : type === "TradeConnect" ? (
          tcSubType === "Initiate" ? (
            <TradeConnectInitiateArchive
              type={type}
              status={status}
              auctionType={"CLOSED"}
            />
          ) : (
            <RFQArchive type={type} status={status} auctionType={"CLOSED"} />
          )
        ) : type === "RFP" ? (
          <RFQArchive
            type={type}
            status={status}
            auctionType={rfpSubType === "Intrastate" ? "CLOSED" : "OPEN"}
          />
        ) : type === "RA" ? (
          <RAArchive
            type={type}
            status={status}
            auctionType={raSubType === "Open" ? "OPEN" : "CLOSED"}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Page_Archive;
